import React from 'react';
import { DateTime } from 'luxon';
import Player from '@vimeo/player';

import { PrimaryButton } from 'Components/Button';

import { resourceDateIsBeforeNow } from 'Services/DateHelpers';
import { translation } from 'Services/TranslationHelpers';

export default class Stream extends React.Component {
    vimeoRef = null;

    supposedCurrentTime = 0;
    canSeek = false;
    player = null;

    state = {
        muted: true,
        subtitles: false,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = () => {
        if (this.props.stream.prerecorded) {
            this.prerecord();
        }
    };

    /**
     * @method componentDidUpdate
     * @param prevProps
     * @param prevState
     * @param snapshot
     */
    componentDidUpdate = (prevProps, prevState, snapshot) => {
        if (this.props.stream.prerecorded && this.player === null) {
            this.prerecord();
        }
    };

    /**
     * @method prerecord
     */
    prerecord = () => {
        this.player = new Player(this.vimeoRef);
        const { starts_at } = this.props.stream;

        const now = DateTime.now();
        const startedAt = DateTime.fromISO(starts_at.iso_string);

        if (resourceDateIsBeforeNow(starts_at)) {
            this.supposedCurrentTime = now.diff(startedAt).milliseconds / 1000;
            // const minutes = Math.floor(millis / 60000);
            // const seconds = ((millis % 60000) / 1000).toFixed(0);
            // startFrom = `${minutes}m${seconds}s`;

            this.player.setCurrentTime(this.supposedCurrentTime).then((seconds) => {
                // seconds = the actual time
            })
        }

        this.player.on('timeupdate', (data) => {
            this.player.getSeeking().then((seeking) => {
                if (!seeking) {
                    this.supposedCurrentTime = data.seconds;
                }
            });
        });

        this.player.on('seeking', (data) => {
            // NB: Uncomment to see the played ranges
            // logPlayedRange();
            if (this.canSeek) {
                return
            }
            // ?? NB: pause first if the position is near the end,
            // Because in fullscreen it can still continue to the end sometimes
            if (data.duration - data.seconds < 10) {
                this.player.pause()
            }
            // accept rewind
            // if (data.seconds < this.supposedCurrentTime) {
            //     return
            // }
            // accept seek to already played time
            isPlayed(data.seconds).then((played) => {
                if (played) {
                    return
                }

                // guard agains infinite recursion:
                // user seeks, seeking is fired, currentTime is modified, seeking is fired, current time is modified, ...
                var delta = data.seconds - this.supposedCurrentTime;

                if (Math.abs(delta) > 0.01) {
                    this.player.setCurrentTime(this.supposedCurrentTime).then((seconds) => {
                        // seconds = the actual time
                    })
                }
            })
        });

        const isPlayed = (time) => {
            return this.player.getPlayed().then(function (played) {
                for (var i = 0; i < played.length; i++) {
                    var start = 0, end = 0;
                    start = played[i][0];
                    end = played[i][1];
                    if (end - start < 1) {
                        continue;
                    }
                    if (time >= start && time <= end) {
                        return true;
                    }
                }
                return false;
            })
        }
    };

    /**
     * @method handleUnmute
     */
    handleUnmute = () => {
        if (this.player) {
            this.player.getMuted().then((v) => {
                this.player.setMuted(!v);

                this.setState({
                    muted: !v,
                });
            });
        }
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const { stream, streamType } = this.props;
        let { active_src, active_subtitle_src, prerecorded } = stream;
        const { muted, subtitles } = this.state;

        let src = active_src;

        if (streamType === 'secondary') {
            src = stream.secondary_stream_src;
        }

        if (subtitles) {
            src = active_subtitle_src;

            if (streamType === 'secondary') {
                src = stream.subtitle_secondary_stream_src;
            }
        }

        return (
            <>
                <div className="lg:bg-video bg-video-container mx-auto">
                    <div className="group relative aspect-w-16 aspect-h-9">
                        <iframe
                            ref={ref => this.vimeoRef = ref}
                            src={`${src}${prerecorded ? `${src.indexOf('?') !== -1 ? '&' : '?'}autoplay=1&muted=1` : ''}`}
                            frameBorder="0"
                            allow="autoplay"
                            allowFullScreen
                            className="w-full h-full inset-0 absolute"
                        />

                        {prerecorded && (
                            <div className={`
                                ${!muted ? 'opacity-0' : ''}
                                group-hover:opacity-100 absolute top-0 left-0 pt-12 w-full 
                                transition duration-200 text-center h-1/2
                            `}>
                                <PrimaryButton
                                    text={muted ? 
                                        translation('main_stage_frontend', 'unmute') : 
                                        translation('main_stage_frontend', 'mute')}
                                    onClick={this.handleUnmute}
                                />
                            </div>
                        )}
                    </div>
                </div>

                {active_subtitle_src &&
                    <div className="flex justify-center items-center mt-6">
                        <PrimaryButton
                            text={subtitles ? 
                                translation('main_stage_frontend', 'disable_subtitles') : 
                                translation('main_stage_frontend', 'enable_subtitles')}
                            onClick={() => this.setState({
                                subtitles: !subtitles
                            })}
                        />
                    </div>
                }
            </>
        );
    }
};
